export default ".grid {\n  display: grid;\n  grid-template-columns: 30px 100px 70px 150px;\n  grid-gap: 5px;\n}";